/* eslint-disable array-callback-return */
import * as Constants from '../utils/constants';

const initialState = {
  loading: false,
  data: null,
  success: false,
  error: false,
  error_msg: '',
};

const AppUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.START_APP_USERS: {
      return {
        ...state,
        loading: true,
      };
    }
    case Constants.APP_USERS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    }
    case Constants.APP_USERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };
    }
    
    case Constants.APP_USERS_RESET: {
      return {
        ...state,
        loading: false,
        error: false,
        error_msg: '',
        success: false,
        data: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default AppUsersReducer;
